<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Breadcrumb, Section, Module } from '@storefront/types';

  defineProps({
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
    sections: { type: Array as PropType<Section[]>, required: true },
    module: { type: Object as PropType<Module>, required: true },
  });
</script>
<template>
  <main id="main" class="container">
    <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    <h1 class="return-delivery-heading" v-html="module.title" />
    <p class="return-delivery-description" v-html="module.descriptionShort" />
    <SectionRenderer :sections="sections" />
  </main>

  <RouterView />
</template>
<style scoped lang="scss">
  .return-delivery-description {
    margin: 1rem 0 2rem;
  }

  @media(max-width: 992px) {
    .return-delivery-heading,
    .return-delivery-description {
      padding: 0 0.625rem;
    }
  }
</style>
